<template>
  <div class="tree-filter-box">
    <el-input
      class="tree-filter"
      :placeholder="placeholder"
      :suffix-icon="icon"
      v-model="filterText"
    >
    </el-input>
    <i
      v-if="filterButton"
      :class="filterButton.icon"
      slot="suffix"
      @click="filterButton.click(filterText)"
    >
    </i>
  </div>
</template>
<script>
export default {
  name: "tree-filter",
  components: {},
  props: {
    treeRef: String,
    placeholder: String,
    icon: String,
    filterButton: Object,
  },
  data() {
    return {
      filterText: "",
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    filterText(val) {
      this.$parent.$refs[this.treeRef].filter(val);
    },
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },

  methods: {
    // transfer(name, data) {
    //   this.$parent.$parent.$parent[name](data);
    // },
    clearFilterText() {
      this.filterText = "";
    },
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: 500px;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.tree-filter-box {
  display: flex;
  justify-content: center;
  align-items: center;
  & > i {
    font-size: 18px;
    margin-right: 5px;
  }
  cursor: pointer;
}
</style>
